// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"FilterLabel_text-gradient__ZYtvI","label":"FilterLabel_label__2lh68","cross":"FilterLabel_cross__350i9","icon":"FilterLabel_icon__27YkX"};